import { authFirebase, googleProvider, appleProvider, signInWithPopup } from "../base/firebase";

async function login(provider, providerName) {
  if (!authFirebase) {
    console.warn("Auth not initialized; missing Firebase config.");
    if (typeof toastr !== 'undefined') { toastr.error("Firebase config missing"); }
    return;
  }
  try {
    let result = await signInWithPopup(authFirebase, provider);
    let access_token = await result.user.getIdToken();

    const res = await fetch("/u/firebase/web_login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        access_token: access_token,
        provider: providerName
      })
    });

    if (res.ok) {
      const data = await res.json();
      if (data.success) {
        toastr.success(data.message);
        setTimeout(() => {
          window.location.href = "/";
        }, 500);
      } else {
        toastr.error("Login failed. Please try again.");
      }
    }
  } catch (err) {
    if (typeof toastr !== 'undefined') { toastr.error("Login failed. Please try again."); }
    console.error(err);
  }
}

window.loginWithGoogle = () => login(googleProvider, "google");
window.loginWithApple  = () => login(appleProvider, "apple");